import { useEffect } from 'react';
import {
  JobDetailResponse,
  ScoutJobDetailResponse,
} from '@doda/api-client/aspida/@types';
import { useSelector } from 'react-redux';
import { appQueryParamsSelector } from '@doda/common/src/redux/features/queryParams';
import { tabSelector } from 'redux/selectors/queryParams';
import { TAB_PHOTOS } from '@doda/common/src/constants/properties/const';
import { adobeAnalyticsScriptsSelector } from '@doda/common/src/redux/features/analytics';
import {
  measureAbTestForManuscriptE,
  measureImpression,
  measureImpressionPublicationPhotoGtm,
} from '../../logics/analytics';
import { Tab } from '../../types/tab';

/**
 * 求人詳細 PV 計測
 * @param job 求人詳細情報
 * @param isScout スカウト求人かどうか
 * @param initialTab 初期選択タブ
 */
export const useImpressionAnalytics = (
  job: JobDetailResponse | ScoutJobDetailResponse,
  isScout: boolean,
  initialTab: Tab
) => {
  const query = useSelector(appQueryParamsSelector);
  const tab = useSelector(tabSelector);
  useEffect(() => {
    if (!job) return;
    if (tab === TAB_PHOTOS) {
      // 写真タブが選択されている場合の計測処理
      measureImpressionPublicationPhotoGtm(job, query, isScout);
    } else {
      measureImpression(job, query, isScout, tab ?? initialTab);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tab]);
};

/**
 * E原稿動画化用PV計測
 * @param abTestForManuscriptEGroupNo - E原稿動画ABテストグループNo
 * @param manuscriptType - 原稿種別
 */
export const useMeasureAbTestForManuscriptE = (
  abTestForManuscriptEGroupNo: number,
  manuscriptType: string | undefined
) => {
  const isAdobeScript = useSelector(adobeAnalyticsScriptsSelector);
  useEffect(() => {
    if (!isAdobeScript || manuscriptType !== 'E') return;
    // PV計測より前に発火しないように発火を遅らせる
    setTimeout(() => {
      measureAbTestForManuscriptE(abTestForManuscriptEGroupNo);
    }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isAdobeScript]);
};
